// Formatter utilities
export const formatGameDateTime = (datetime, durationMinutes) => {
  if (!datetime) return "Date and time not set";
  const date = new Date(datetime);
  const weekday = date.toLocaleDateString("en-GB", { weekday: "long" });
  const dayMonth = date.toLocaleDateString("en-GB", {
    day: "numeric",
    month: "long",
  });
  const startTime = date.toLocaleTimeString("en-GB", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });

  if (!durationMinutes) {
    return `${weekday}, ${dayMonth}, ${startTime}`;
  }

  const endTime = new Date(
    datetime + durationMinutes * 60000,
  ).toLocaleTimeString("en-GB", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });

  return `${weekday}, ${dayMonth}, ${startTime} – ${endTime}`;
};
